const LAYERS = {
  baseUrl: 'https://sarudoli.axiohm.cz/uploads/maps/'
};

const MAP_BOUNDS = {
  north: 51.2,
  south: 48.5,
  west: 11.97,
  east: 19.1
};

const hidePOI = [
  {
    featureType: 'poi',
    elementType: 'labels.text',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  },
  {
    featureType: 'poi.business',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  },
  {
    featureType: 'road',
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  },
  {
    featureType: 'transit',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  }
];

const MAP_SETTINGS = {
  zoom: 11,
  //minZoom: 10,
  center: { lat: 50.10525911364775, lng: 14.332079666748086 },
  clickableIcons: false,
  mapTypeControl: true,
  /*mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.VERTICAL_BAR,
        position: google.maps.ControlPosition.BOTTOM_LEFT
    },*/
  restriction: {
    latLngBounds: MAP_BOUNDS,
    strictBounds: false
  },
  gestureHandling: 'greedy',
  //center: {lat: 0.00714587774645862, lng: 0.00682329998492174}
  styles: hidePOI,
  mapTypeId: 'roadmap'
};

/*const MARKER_ICONS = {
  Obyvatel: {
    path: 'M 0 20 L 0 40 L 20 40 L 20 20 L 0 20 Z',
    fillColor: 'green',
    fillOpacity: 0.8,
    scale: 1,
    strokeColor: 'green',
    strokeWeight: 1
  },
  Majitel: {
    path: 'M 0 20 L 0 40 L 20 40 L 20 20 L 0 20 Z',
    fillColor: 'yellow',
    fillOpacity: 0.8,
    scale: 1,
    strokeColor: 'gold',
    strokeWeight: 1
  }
}*/

const MARKER_ICONS = {
  Obyvatel: 'https://sarudoli.axiohm.cz/gm/pin-Obyvatel-v3.png',
  Majitel: 'https://sarudoli.axiohm.cz/gm/pin-Majitel-v3.png',
  Zpracovatel: 'https://sarudoli.axiohm.cz/gm/pin-Zpracovatel-v3.png',
  Info: 'https://sarudoli.axiohm.cz/gm/pin-Info.png'
};

export { MAP_SETTINGS, MAP_BOUNDS, MARKER_ICONS, LAYERS };
